export const APP_DEF_ID = '7638bcfe-c8f5-4a88-8753-79dd6ca22b01';
export const SHUB_APP_DEF_ID = 'fd22db0e-2dec-47ea-8d6b-d5232742f6cb';
export const STORES_APP_DEF_ID = '215238eb-22a5-4c36-9e7b-e7c08025e04e';
